import { createContext, useContext, useState } from "react";

const FindAClassContext = createContext();

export const useFindAClass = () => useContext(FindAClassContext);

export const FindAClassProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openFindAClass = () => setIsOpen(true);
  const closeFindAClass = () => setIsOpen(false);

  return (
    <FindAClassContext.Provider value={{ isOpen, openFindAClass, closeFindAClass }}>
      {children}
    </FindAClassContext.Provider>
  );
};
